<template>
  <div class="recipe">
    <myNav />
    <div class="bannerr">
      <div class="y900">
        <div class="rzpart1">
          <h1>企业入驻平台</h1>
          <h2>快速入驻</h2>
          <div class="to">
            <img
              src="../assets/images/rz_dz.png"
              class="to_img"
              @click="todzrz()"
            />
            <img src="../assets/images/sj_rz.png" @click="tosjrz()" />
          </div>
        </div>
        <div class="rzpart2">
          <p>入驻优势</p>
          <div class="tab">
            <el-tabs :tab-position="tabPosition" style="height: 200px">
              <el-tab-pane
                :label="item.title"
                v-for="(item, index) of nice"
                :key="index"
              >
                <img :src="item.pic" class="img" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div class="y1080">
        <div class="rzpart3">
          <p>他们都在用诚企服平台</p>
          <div class="pics">
            <div :label="join[0].title" v-if="join[0]" class="join1">
              <img :src="join[0].pic" class="img" />
            </div>
            <div :label="join[1].title" v-if="join[1]" class="join2">
              <img :src="join[1].pic" class="img" />
            </div>
            <div :label="join[2].title" v-if="join[2]" class="join3">
              <img :src="join[2].pic" class="img" />
            </div>
            <div :label="join[3].title" v-if="join[3]" class="join4">
              <img :src="join[3].pic" class="img" />
            </div>
            <div :label="join[4].title" v-if="join[4]" class="join5">
              <img :src="join[4].pic" class="img" />
            </div>
            <!-- <div :label="item.title" v-for="(item, index) of join" :key="index">
              <img :src="item.pic" class="img" />
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      keyword: "",
      link: "",
      list: [],
      tabPosition: "left",
      join: [],
      nice: [],
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$axios({
        url: "Index/join_index",
        method: "GET",
        params: {},
      }).then((res) => {
        console.log(res, "优势");
        this.join = res.data.data.join;
        this.nice = res.data.data.nice;
      });
      this.$axios({
        url: "/Index/company_list",
        method: "GET",
        params: {
          page: this.page,
          pageSize: this.pageSize,
          keyword: this.keyword,
        },
      }).then((res) => {
        console.log("我可以获取到审计列表数据吗", res);
        this.list = res.data.data.list;
      });
    },
    todzrz() {
      this.$router.push({
        path: "dzrz_detail",
      });
    },
    tosjrz() {
      this.$router.push({
        path: "sjrz_detail",
      });
    },
    search(keyword) {
      this.keyword = keyword;
      this.get();
    },
  },
};
</script>
<style scoped lang="less">
.list {
  width: 100%;
  height: 250px;
  padding-top: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e5e5e5;
}
.list_left {
  float: left;
  width: 75%;
}
.list_right {
  float: right;
  width: 267px;
  height: 180px;
  border: 1px solid #000;
  border-radius: 5px;
  box-sizing: content-box;
}
.list_right img {
  object-fit: contain;
  width: 267px;
  height: 180px;
}
.list_left h1 {
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 25px;
}
.list_left p {
  padding-top: 30px;
  font-size: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 60px;
}
.list_left div {
  margin-top: 50px;
  width: 78px;
  height: 27px;
  border-radius: 5px;
  border: 1px solid;
  color: #558bd4;
  line-height: 27px;
  text-align: center;
}
.page {
  padding-top: 20px;
  padding-bottom: 20px;
}
.bannery h1 {
  text-align: center;
  padding-top: 118px;
  font-size: 30px;
  color: #fff;
}
.bannery h2 {
  text-align: center;
  padding-top: 14px;
  font-size: 20px;
  color: #fff;
}
.bannery p {
  width: 100px;
  height: 44px;
  border: 1px solid;
  border-radius: 5px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  line-height: 44px;
  display: block;
  margin: 0 auto;
  margin-top: 65px;
}
.input_s {
  padding-top: 80px;
  margin: 0 auto;
  width: 500px;
  height: 40px;
  display: block;
  position: relative;
}
.upinput {
  width: 500px;
  height: 40px;
  display: block;
}
.rzpart1 {
}
.rzpart1 h1 {
  font-size: 40px;
  color: #fff;
  padding-top: 75px;
  font-weight: 800;
}
.rzpart1 h2 {
  font-size: 20px;
  color: #fff;
  padding-top: 20px;
}
.rzpart1 .to {
  display: inline-block;
  padding-top: 50px;
}
.to_img {
  padding-right: 25px;
}
.rzpart2 p {
  padding-top: 50px;
  padding-bottom: 50px;
  font-size: 40px;
  color: #fff;
  font-weight: 800;
}
.tab {
  width: 100%;
  height: 220px;
  border-radius: 5px;
  background: #fff;
}
.tab img {
  width: 600px;
  height: 178px;
  object-fit: cover;
  margin-left: 100px;
  margin-top: 20px;
  border: 1px solid #2c23cf;
  border-radius: 5px;
}
/deep/.tab .el-tabs__item {
  font-size: 20px;
  padding-left: 20px;
  color: #2c23cf;
}
.rzpart3 {
}
.rzpart3 p {
  color: #2c23cf;
  font-size: 40px;
  padding-top: 50px;
  padding-bottom: 50px;
  text-align: center;
  font-weight: 800;
}
.pics {
  padding-top: 50px;
  padding-bottom: 50px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  height: 500px;
}
.pics div {
  display: inline-block;
  width: 216px;
  height: 58px;
  border-radius: 10px;
  padding-bottom: 10px;
}
.pics div img {
  width: 216px;
  height: 58px;
  object-fit: cover;
  border-radius: 35px;
  padding-left: 5px;
  padding-right: 5px;
}
.join1 {
  position: absolute;
  top: 50px;
  left: 0;
}
.join2 {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translate(-50%);
}
.join3 {
  position: absolute;
  top: 50px;
  right: 0;
}
.join4 {
  position: absolute;
  top: 150px;
  left: 205px;
}
.join5 {
  position: absolute;
  top: 150px;
  right: 205px;
}
.y1080 {
  width: 1080px;
  margin: 0 auto;
}
</style>

